import type { TrendListResponsePage } from './trendListResponsePage';

export interface TrendListResponse {
  code?: string;
  message?: string;
  page?: TrendListResponsePage;
  success?: boolean;
}
